__turbopack_context__.v({
  "OpenNoteTrigger": "note-content-module__qbuwha__OpenNoteTrigger",
  "QuestionMark": "note-content-module__qbuwha__QuestionMark",
});
